import { useTranslation } from "next-i18next";

import header from "../header.module.css";

type MenuButtonProps = {
  isOpen?: boolean;
  toggleOpen: () => void;
};

export const MenuButton = ({ isOpen = false, toggleOpen }: MenuButtonProps) => {
  const { t } = useTranslation("header");

  return (
    <button className={header.menu_button} onClick={toggleOpen}>
      {t(isOpen ? "menu.close" : "menu.open")}
    </button>
  );
};
